import React, { ReactNode, useState } from "react";
import {
  LieutenantBagdgeIcon,
  CfoBadgeIcon,
  MentorBadgeIcon,
  CaptainBadgeIcon,
  GeneralBadgeIcon,
} from "../../../icons/badge-icons";

interface ProfileBadgeAvatar {
  profileImage: string;
  customDivClassName?: string;
  customImgClassName?: string;
  customIconDivClassName?: string;
  customStarWidth?: number;
  customStarHeight?: number;
  customStyle1?: string;
  customStyle2?: string;
  customStyle3?: string;
  badge?: string;
}

const badgeColors: Record<
  string,
  { borderColor1: string; borderColor2: string; icon?: ReactNode }
> = {
  GENERAL: {
    borderColor1: "#F4D169",
    borderColor2: "#7E744D",
    icon: <GeneralBadgeIcon />,
  },
  LIEUTENANT: {
    borderColor1: "#AB6E1F",
    borderColor2: "#F0DF9A",
    icon: <LieutenantBagdgeIcon />,
  },
  CAPTAIN: {
    borderColor1: "#E4E4E4",
    borderColor2: "#797979",
    icon: <CaptainBadgeIcon />,
  },
  MENTOR: {
    borderColor1: "#007AFF",
    borderColor2: "#CFCFCF",
    icon: <MentorBadgeIcon />,
  },
  CFO: {
    borderColor1: "#9A89E0",
    borderColor2: "#EFEFEF",
    icon: <CfoBadgeIcon />,
  },
};

const ProfileBadgeAvatar: React.FC<ProfileBadgeAvatar> = ({
  profileImage,
  customDivClassName,
  customImgClassName,
  customIconDivClassName,
  customStyle3,
  customStarWidth,
  customStarHeight,
  customStyle1,
  customStyle2,
  badge,
}) => {
  const [loading, setLoading] = useState(true);

  const borderColors = badge ? badgeColors[badge] : null;

  return (
    <div className="h-4">
      <div
        className={`rounded-full ${customDivClassName || ""}`}
        style={{ borderColor: borderColors?.borderColor1 }}
      ></div>
      <div
        className={`relative rounded-full overflow-hidden ${customImgClassName || ""} ${loading ? "hidden" : ""}`}
      >
        <div className="relative z-[11]">
          {loading && (
            <div className="bg-gray-300 rounded-full h-full w-full"></div>
          )}
          <img
            src={profileImage}
            alt="Profile"
            className={`${customStyle3} rounded-full `}
            onLoad={() => setLoading(false)}
            style={{ display: loading ? "none" : "block" }}
          />
        </div>
        {!loading && (
          <div
            className={`${customStyle1}`}
            style={{ backgroundColor: borderColors?.borderColor1 }}
          ></div>
        )}
        <div
          className={`${customStyle2}`}
          style={{ backgroundColor: borderColors?.borderColor2 }}
        ></div>
      </div>
      <div className={`${customIconDivClassName}`}>
        {borderColors?.icon ? (
          React.cloneElement(borderColors.icon as React.ReactElement, {
            width: customStarWidth || 32,
            height: customStarHeight || 32,
          })
        ) : (
          <GeneralBadgeIcon
            width={customStarWidth || 32}
            height={customStarHeight || 32}
          />
        )}
      </div>
    </div>
  );
};
export default ProfileBadgeAvatar;
